import Card from '@material-ui/core/Card'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardContent from '@material-ui/core/CardContent'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import React from 'react'

type Props = {
    text: string
}
const useStyles = makeStyles({
    root: {
        width: 345,
        height: 345,
        display: 'flex',
        backgroundColor: '#33949E'

    }
})

export const TextCard : React.FC<Props> = ({ text }) => {
    const classes = useStyles()

    return (
        <div
            style={{ padding: 10, backgroundColor: 'white', margin: 15 }}>
            <Card className={classes.root}>

                <CardActionArea>
                    <CardContent style={{
                        display: 'flex', justifyContent: 'center', alignItems: 'center', alignContent: 'center' 
                    }}>
                        <Typography
                            variant="h5"
                            style={{
                                fontFamily: 'Encode, sans-serif', letterSpacing: 1, textAlign: 'center', color: 'white' 
                            }}>
                            {text}
                        </Typography>
                    </CardContent>
                </CardActionArea>
            </Card>
        </div>
    )
}
